import { createFileRoute } from '@tanstack/react-router';
import {
  loadProductRulesMessages,
  loadProductRulesScreens,
  productRuleDetailScreen,
  productRuleDetailSearch,
} from '@/modules/credit-product-rules/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

export const Route = createFileRoute('/_app/cadastro/configuracao-regras/$ruleId/')({
  validateSearch: productRuleDetailSearch,
  staticData: { screen: productRuleDetailScreen },
  loader: () => loadProductRulesMessages(),
  component: lazyScreen(loadProductRulesScreens, 'ProductRuleFormPage'),
});
